var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"marker-acronym",style:({ backgroundColor: _vm.acronym.color })},[_vm._v(" "+_vm._s(_vm.acronym.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }